import styled from 'styled-components';

const NavWrapper = styled.div`
  float: right;
  margin-top: 10px;
`;

export default NavWrapper;


// WEBPACK FOOTER //
// ./src/components/Header/NavWrapper.js